module.exports = __webpack_public_path__ + "static/media/logo.449bc8e6.svg";